import { useIsMountedRef, useMountEffect } from "@opensea/ui-kit/hooks";
import { useState } from "react";
import { useTrackError } from "../../providers/TrackErrorProvider";
import { MOONPAY_API_CHECK_IP_URL } from "./constants";
let moonPayAllowedCache;
export const clearMoonPayAllowedCache = () => {
  moonPayAllowedCache = undefined;
};
export const useIsMoonPayAllowed = ({
  allowedByDefault = false
} = {}) => {
  const [state, setState] = useState({
    isTopupAllowed: allowedByDefault,
    isBuyWithCardAllowed: allowedByDefault,
    isMintAllowed: allowedByDefault,
    isLoading: true
  });
  const isMountedRef = useIsMountedRef();
  const trackError = useTrackError();
  useMountEffect(() => {
    const ipCheck = async () => {
      try {
        const {
          isBuyAllowed,
          isNftAllowed,
          state: state_0
        } = await checkIP(trackError);
        if (isMountedRef.current) {
          moonPayAllowedCache = {
            isTopupAllowed: isBuyAllowed,
            isMintAllowed: isNftAllowed && state_0 !== "NY",
            isBuyWithCardAllowed: isNftAllowed
          };
          setState({
            ...moonPayAllowedCache,
            isLoading: false
          });
        }
      } catch (error) {
        trackError(error);
        if (isMountedRef.current) {
          setState({
            isTopupAllowed: false,
            isBuyWithCardAllowed: false,
            isMintAllowed: false,
            isLoading: false
          });
        }
      }
    };
    if (moonPayAllowedCache) {
      setState({
        ...moonPayAllowedCache,
        isLoading: false
      });
    } else {
      ipCheck();
    }
  });
  return state;
};
const checkIP = async trackError => {
  try {
    const response = await fetch(MOONPAY_API_CHECK_IP_URL);
    if (!response.ok) {
      // if request fails, assume that moonpay features are not available
      return {
        isBuyAllowed: false,
        isNftAllowed: false,
        state: null
      };
    }
    const json = await response.json();
    return json;
  } catch (error) {
    trackError(error);
    return {
      isBuyAllowed: false,
      isNftAllowed: false,
      state: null
    };
  }
};